import {TShow} from '../../../../component/prompotionPopup/PromotionPopup';
import TableDetailsPop, {DetailItem} from '../../../components/tableDetailsPop/TableDetailsPop';
import {HeaderActions, BottomActions} from './PopupActions';
import {SubscriptionPlan} from '../../../../redux/subscription/subscription.type';
import {formatDate, seriesTypeLabel} from '../../utils/subscriptionUtils';
import {useTranslation} from 'react-i18next';
import {defaultImage} from '../../../../assets/symbols/images/defaultImage';
import {calculatePercentage, calculatePriceRange, calculateSalesFraction, calculateSaleValidity} from '../../utils/planCalculations';
import {setCurrentPlan, updatePlan} from '../../../../redux/subscription/subscriptionActions';
import useGlobalShow from '../../../../hooks/useGlobalShow';
import {useState} from 'react';
import {Label} from '@tickchak/react-share/app';

function DetailsPop({plan, detailsPopShow, onCloseDetails, onOpenAssigningEvents}: {plan: SubscriptionPlan; detailsPopShow: TShow; onCloseDetails: () => void; onOpenAssigningEvents: (plan: SubscriptionPlan) => void;}) {
    const {t} = useTranslation('subscriptions');
    const expirationDate = formatDate(plan.usageDeadline);
    const createSubscriptionShow = useGlobalShow('isOpenCreateSubscription');
    const [status, setStatus] = useState<boolean>(plan.active);

    const details: DetailItem[] = [
        {label: t('saleValidity'), value: calculateSaleValidity(plan) || '-'},
        {label: t('sales'), value: calculateSalesFraction(plan)},
        {label: t('realization'), value: `${calculatePercentage(plan)}%`},
        ...(expirationDate ? [{label: t('expirationDate'), value: expirationDate}] : []),
        {label: t('priceRange'), value: calculatePriceRange(plan)},
    ];

    const handleEdit = () => {
        detailsPopShow.close();
        setCurrentPlan(plan.planTid);
        createSubscriptionShow.open();
    };
    
    const handleAssociateEvents = () => {
        detailsPopShow.close();
        onOpenAssigningEvents(plan);
    };
    
    const handleAssociateGroups = () => {
        // TODO: Implement associate groups
        console.log('Associate groups', plan.planTid);
    };
    
    const handleActive = () => {
        updatePlan(plan.planTid, {active: !status}).then(() => {
            setStatus(!status);
        });
    };
    const subtitle = <Label backgroundColor={seriesTypeLabel[plan.planType]?.color}>
        {t(seriesTypeLabel[plan.planType]?.label)}
    </Label>;
    return (
        <>
            {detailsPopShow.isOpen && (
                <TableDetailsPop 
                    title={plan.title}
                    subtitle={subtitle}
                    image={defaultImage}
                    details={details}
                    headerActions={<HeaderActions plan={plan} status={status} handleActive={handleActive} />}
                    actions={
                        <BottomActions 
                            plan={plan}
                            onEdit={handleEdit}
                            onAssociateEvents={handleAssociateEvents}
                            onAssociateGroups={handleAssociateGroups}
                        />
                    }
                    show={detailsPopShow}
                    onClose={onCloseDetails}
                    dataCyName="subscriptionDetails"
                />
            )}
        </>
    );
}

export default DetailsPop;